module.exports = __webpack_public_path__ + "static/media/afrojack.90aee971.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/clients/afrojack.png
// module id = 221
// module chunks = 0